import React, { useContext, useEffect } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { onlyUnique } from "../../../utils/dataFunctions";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { vsfpData } from "../../../api/s3";
import { Loader } from "../../../components/loader/Loader";
import palettedata from "../../../data/palette.json";
import {
  onAction,
  factory,
  layoutModelChange,
  onRenderTabSet,
  onRenderTab,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

const palette = palettedata.map((item) => item["hex code"]);

const filterKeys = ["ModelDate", "Ticker", "Horizon", " Pctile "];

export const BreakageAndReturnLayout = () => {
  const [store] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState, setLayoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);

  const { auth, debug, defaultTicker } = store;
  const { breakageandreturn, filter } = lstore;

  if (debug) {
    console.log("BreakageAndReturnLayout");
  }

  useEffect(() => {
    let isCancelled = false;

    const asyncfunction = async () => {
      ldispatch({ type: lactionTypes.SET_LOADING, payload: true });
      const newState = {
        rawdata: [],
      };

      const sdata = await vsfpData(auth, grefs.tickerStorage.current);

      newState.rawdata = sdata;

      const sortAlphaNum = (a, b) =>
        a.localeCompare(b, "en", { numeric: true });

      const defaults = filterKeys.reduce((a, b) => {
        return {
          ...a,
          [b]: newState.rawdata
            .map((item) => (item[b] === null ? "" : item[b].toString()))
            .filter(onlyUnique)
            .sort(sortAlphaNum),
        };
      }, {});

      defaults.Ticker.sort().forEach((item, i) => {
        refs.tickerPalette.current[item] = palette[i];
      });

      defaults.ModelDate.sort((a, b) => {
        return new Date(b) - new Date(a);
      });

      // defaults["RiskModel"].unshift("All");
      defaults["Ticker"].unshift("All");
      defaults["ModelDate"].unshift("All");
      defaults[" Pctile "].unshift("All");
      // defaults["Horizon"].unshift("All");

      const tickerSelection = Array.from(new Set(["SPY", defaultTicker]));

      ldispatch({
        type: lactionTypes.SET_FILTER_DEFAULTS,
        payload: JSON.parse(JSON.stringify(defaults)),
      });
      ldispatch({
        type: lactionTypes.SET_FILTER,
        payload: {
          Ticker: tickerSelection,
          ModelDate: [...defaults.ModelDate],
          Horizon: ["21"],
          // RiskModel: [...defaults.RiskModel],
          " Pctile ": [...defaults[" Pctile "]],
        },
      });

      if (!isCancelled) {
        ldispatch({
          type: lactionTypes.SET_BREAKAGEANDRETURN,
          payload: newState,
        });
        ldispatch({ type: lactionTypes.SET_LOADING, payload: false });
      }
    };
    asyncfunction();

    return () => {
      isCancelled = true;
    };
  }, [auth, ldispatch, grefs.tickerStorage, refs.tickerPalette, defaultTicker]);

  if (
    layoutState.model &&
    breakageandreturn &&
    breakageandreturn.rawdata.length > 0
  ) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={(node) => factory(node, filter)}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) =>
          layoutModelChange(model, layoutState, setLayoutState, grefs)
        }
        onAction={(action) => onAction(action, layoutState)}
        onRenderTab={(node, renderState) =>
          onRenderTab(node, renderState, refs.componentSize)
        }
      />
    );
  } else {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }
};
